import React, {useContext} from 'react';
import NavigationMenuSvg from 'util/svg/NavigationMenuSvg';
import {useSessionConfiguration} from 'util/SessionConfigurationContext';
import {UserContext} from 'components/user/UserContext';
import QuestionMark from 'components/menu/QuestionMark';

const UniversalEmptyPageHeader = ({
                                      image,
                                      text,
                                      children,
                                      desktopText = false,
                                      click,
                                      twoFloors = false,
                                      desktopHeaderScale = 1,
                                      translateX = 0
                                  }) => {
    const {isDesktopView} = useSessionConfiguration();
    const {isCashTenant} = useContext(UserContext);

    const safeClick = () => {
        if (click) {
            click();
        }
    };

    return (
        <div
            style={{
                paddingLeft: '12px', width: '100%'
            }}
            className={`market-options-header ${isDesktopView ? 'padding-less' : 'mobile'} ${twoFloors ? 'two-floors' : ''}`}
        >
            <div className={`header-tooltip-absolute ${isDesktopView ? '' : 'mobile'}`}>
                <QuestionMark/>
            </div>

            <div className="market-left-section">
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: isDesktopView ? '2px 0' : '0',
                    minHeight: 48,
                    gap: isDesktopView ? '2px' : '8px',
                    transform: `translateX(${translateX}px)`
                }}
                     onClick={safeClick}>
                    <NavigationMenuSvg
                        name={image}
                        color={'#4E6C55'}
                        size={isDesktopView ? 44 * desktopHeaderScale : 48}
                        isMoneyTenant={isCashTenant}
                    />
                    {(!isDesktopView || desktopText) && (
                        <div
                            className={`market-options-header-mobile-title ${isDesktopView ? '' : 'mobile'}`}>{text}</div>
                    )}
                </div>
            </div>

            <div className="market-middle-section">
                {children}
            </div>
        </div>
    );
};

export default UniversalEmptyPageHeader;